import { render, staticRenderFns } from "./NewWaybillEntry.vue?vue&type=template&id=251f8670&scoped=true&"
import script from "./NewWaybillEntry.vue?vue&type=script&lang=js&"
export * from "./NewWaybillEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewWaybillEntry.vue?vue&type=style&index=0&id=251f8670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f8670",
  null
  
)

export default component.exports